import { render, staticRenderFns } from "./GlobalSettings.vue?vue&type=template&id=7e73dc95"
import script from "./GlobalSettings.vue?vue&type=script&lang=ts"
export * from "./GlobalSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports